import type { FieldMiddleware } from '@nestjs/graphql'

/**
 * Field middleware for a flag saying whether the record holds a value in `field`, for callers who may not see the
 * value itself. A book's file paths are only sent to its owner and to staff (see ownerOrStaffOnly), but every
 * reader still needs to know whether there is an epub or a pdf to offer [sc-28919].
 *
 * It reads the stored value straight off the record rather than resolving `field`, so the flag holds whichever
 * query built the record and whoever is asking.
 */
export const presenceOf = (field: string): FieldMiddleware<Record<string, unknown>> => ({ source }) => {
  const value = source[field]
  return typeof value === 'string' && value !== ''
}
